import React from 'react';
import { Icon } from './Icon.js';
export const IconWindowBottomLeftFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "M9.25 11C10.7688 11 12 9.76878 12 8.25V3.75C12 2.23122 10.7688 1 9.25 1H2.75C1.23122 1 0 2.23122 0 3.75V8.25C0 9.76878 1.23122 11 2.75 11H9.25ZM2.75 9C2.33579 9 2 8.66421 2 8.25V6.25C2 5.83579 2.33579 5.5 2.75 5.5H4.75C5.16421 5.5 5.5 5.83579 5.5 6.25V8.25C5.5 8.66421 5.16421 9 4.75 9H2.75Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconWindowBottomLeftFill12.js.map